module.exports = __webpack_public_path__ + "static/media/star-empty.aaf24e2f.svg";